import React from 'react';

export default function UnprotectedEdge({ className }) {
    return (
        <svg className={`${className}  w-8 h-8`} fill="#e20303" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2L2 22h20L12 2zm0 3.5l7.36 14H4.64L12 5.5zM11 15h2v2h-2v-2zm0-6h2v4h-2V9z"/>
        </svg>
    );
}